import type { Permission } from '../../../../shared/auth';
import type { NavigationItem } from './types';

type UserLike = {
  permissions?: Permission[];
  isAdmin?: boolean;
} | null | undefined;

export const hasRequiredPermission = (
  user: UserLike,
  item: NavigationItem
): boolean => {
  if (!user) return false;
  if (item.adminOnly) return user.isAdmin ?? false;
  if (item.permissions?.length) {
    const hasPermission = item.permissions.some((p) =>
      user.permissions?.includes(p)
    );
    if (user.isAdmin) {
      return item.showForAdmin === true;
    }
    return hasPermission;
  }
  return true;
};

export const filterItemsByPermission = (
  items: NavigationItem[],
  user: UserLike
): NavigationItem[] => items.filter((item) => hasRequiredPermission(user, item));

export const isPathActive = (pathname: string, to: string) =>
  pathname === to || pathname.startsWith(`${to}/`);
